import React, { useEffect, useState } from 'react';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import {
  DataSourceBubbleInfo,
  DATASOURCE_NAME,
} from '@/pages/intelligence/components/DataSourceComponents';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { useIntl, getLocale } from 'umi';
import { LANGUAGE_CN } from '@/pages/home/_config/config';

import type { IDataCompareData, IDataCompareHelper } from '@intelligence/v3/components/DataCompareBubble';

interface ColumnType {
  key: string;
  title: string;
  dataSource: string;
  currentSortKey: string;
  currentSortValue: '' | 'desc' | 'asc';
  onSortChage: (e: SortByItemType) => void;
  sortMetric: string;
  textContent: React.ReactNode;
  isNoDropdown?: boolean;
  getMetricValueOfCvm: (cvm: any, metricKey: string) => {
    value: string | number;
    growthDataObj: {
      value: string | number;
      type: string;
    };
    dataCompareData?: IDataCompareData & IDataCompareHelper;
  };
  svgIcon?: any;
  metricKey?: string;
  entityType?: string
}

export const SteamingMetricColumn = (params: ColumnType) => {
  const {
    key,
    title,
    sortMetric,
    dataSource,
    currentSortKey,
    currentSortValue,
    textContent,
    isNoDropdown,
    svgIcon,
    onSortChage,
    getMetricValueOfCvm = () => console.log,
    width = 180,
    width_cn,
    metricKey = '',
    entityType = ''
  } = params;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const localeWidth = locale === LANGUAGE_CN ? width_cn || width : width;

  return {
    key: key,
    width: 'auto',
    align: 'center',
    header: (
      <CloumsCenter width={localeWidth} align={'right'}>
        <SortBy
          title={title}
          defaultKey={currentSortKey}
          defaultValue={currentSortValue}
          svgIcon={svgIcon ?? undefined}
          isNoDropdown={isNoDropdown}
          list={[
            {
              key: `${key}_0`,
              sortMetric: sortMetric,
              orderSource: dataSource,
              text: title,
              title: title,
              ratioType: 0,
            },
            {
              key: `${key}_1`,
              sortMetric: sortMetric,
              orderSource: dataSource,
              text: `${title}:${formatMessage({ id: 'dbi_change' })}(%)`,
              title: `${title}(%)`,
              ratioType: 1,
            },
          ]}
          onChange={onSortChage}
          svgTip={
            <DataSourceBubbleInfo
              dataOfDom={title}
              metricKey={metricKey}
              entityType={entityType}
              comesFormDom={
                <>
                  <img src={getDataSourceIcon(dataSource)} />
                  {DATASOURCE_NAME[dataSource]}
                </>
              }
              dataSource={'hatchet'}
            />
          }
          content={textContent}
        />
      </CloumsCenter>
    ),
    render: (cvm: any) => {
      const { value, growthDataObj, dataCompareData } = getMetricValueOfCvm(cvm, key);
      return (
        <CloumsCenter width={localeWidth} align={'right'}>
          <TableShowData
            maxNumber={'99999+%'}
            value={value}
            type={growthDataObj?.type}
            growth={growthDataObj?.value}
            dataCompareData={dataCompareData}
          />
        </CloumsCenter>
      );
    },
  };
};
